export const GetUniversityListConst = "GetUniversityList";
export const GetAgentListConst = "GetAgentList";
export const GetUserListConst = "GetUserList";
export const GetOrganizationListConst = "GetOrganizationList";
export const GetRoleListConst="GetRoleList"
export const GetCatalogListConst="GetCatalogList"
export const GetProcessListConst="GetProcessList"
export const SaveRolesConst="SaveRoles"
export const GetUserChatConst="GetUserChat"
export const GetUserChatByIdConst="GetUserChatById"
export const GetBranchByOrgIdConst="GetBranchByOrgId"
export const GetFilteredUserConst="GetFilteredUser"
export const GetProgramListConst="GetProgramList"
export const GetCountryListConst="GetCountryList"
export const GetContractListConst= "GetContractList"
export const GetStateListConst="GetStateListService"
export const PromotedUniversityConst="PromotedUniversity"
export const GetCurrencyListConst="GetCurrencyList"

export const GetSettingCountConst="GetSettingCount"
export const GetDegreeList="GetDegreeList"